export interface ICustomerNavLinkDescriptor {
  title: string;
  icon: JSX.Element;
  viewId: string;
  mosiacPanel?: string;
}

export interface ICustomerFeature {
  viewId: string;
  navLink: ICustomerNavLinkDescriptor;
  component: (props: any) => JSX.Element;
}

let registered: ICustomerFeature | null = null;

export const setCustomerFeature = (feature: ICustomerFeature): void => {
  registered = feature;
};

export const getCustomerFeature = (): ICustomerFeature | null => registered;

export const getCustomerComponent = (viewId: string): ((props: any) => JSX.Element) | null => {
  if (registered && registered.viewId === viewId) {
    return registered.component;
  }
  return null;
};

export const isCustomerViewId = (viewId: string): boolean => {
  return registered?.viewId === viewId;
};
